export default [
  { to: 'STÖD SOM PATIENT', title: 'STÖD SOM PATIENT' },
  { to: 'STÖD I ARBETET', title: 'STÖD I ARBETET' },
  { to: 'PERSONAL', title: 'PERSONAL' },
  { to: 'DOSKALKYLATOR', title: 'DOSKALKYLATOR' },
];
